import { App } from '@df/core/app';
import { NICmsContentComponent, NICmsContentField } from '@icms/core/content';
export namespace NUgcImageGallery {
    export const FIELDS = [
        <NICmsContentField.IField>{
            key: 'title',
            type: NICmsContentField.EFieldType.text,
            title: 'Title',
            required: true
        },
        <NICmsContentField.IField>{
            key: 'subtitle',
            type: NICmsContentField.EFieldType.text,
            title: 'Subtitle',
            required: true
        },
        <NICmsContentField.IField>{
            key: 'cta',
            type: NICmsContentField.EFieldType.text,
            title: 'CTA',
            required: true
        },
        <NICmsContentField.INumberField>{
            key: 'limit',
            type: NICmsContentField.EFieldType.number,
            title: 'Limit',
            step: 1,
            required: true,
            default: 20,
            max: 50,
            min: 1
        },
        <NICmsContentField.IField>{
            key: 'message',
            type: NICmsContentField.EFieldType.textarea,
            title: 'Message'
        }
    ];
    export const UGC_CATEGORY_FIELD: NICmsContentField.IChoiceField = {
        key: 'ugc_category',
        multiple: true,
        type: NICmsContentField.EFieldType.choice,
        title: 'UGC Category',
        options: () => {
            if (typeof window !== 'undefined') {
                const attr = (<App>window['app'])?.resources?.attribute?.get('ugc_category');
                if (attr?.data?.options) {
                    return attr.data.options.map(i => {
                        return {
                            key: i.value,
                            value: i.value,
                            title: i.label.toString()
                        };
                    });
                }
            }
            return [];
        }
    };
    export const UGC_RANGE_CODE_NH_FIELD: NICmsContentField.IChoiceField = {
        key: 'nyw_item_range_code_nh',
        multiple: true,
        type: NICmsContentField.EFieldType.choice,
        title: 'Range Code NH',
        options: () => {
            if (typeof window !== 'undefined') {
                const attr = (<App>window['app'])?.resources?.attribute?.get('nyw_item_range_code_nh');
                if (attr?.data?.options) {
                    return attr.data.options.map(i => {
                        return {
                            key: i.value,
                            value: i.value,
                            title: i.label.toString()
                        };
                    });
                }
            }
            return [];
        }
    };
    export interface IData extends NICmsContentComponent.IData {
        title: string;
        subtitle: string;
        cta: string;
        limit: number;
        ugc_category?: number | number[];
        nyw_item_range_code_nh?: number | number[];
        message?: string;
    }
    export interface IListingData extends IData {
        text?: string;
        initialStepsVisible: number;
        infScrollStep: number;
    }
}
